import LoginError from './LoginError';
class InactiveAccount extends LoginError {
    constructor(options) {
        super('Login blocked due to inactivity', options);
    }
}
export default InactiveAccount;
